/**
 * Validate GitHub repository URL - accepts both simple repos and file URLs
 * @param {string} url - GitHub URL to validate
 * @returns {boolean}
 */
export const isValidGithubUrl = (url) => {
  // Accept both simple repo URLs and full file URLs
  const simpleRepoRegex = /^https?:\/\/(www\.)?github\.com\/[a-zA-Z0-9-]+\/[a-zA-Z0-9._-]+(\/)?(.git)?$/;
  const fileUrlRegex = /^https?:\/\/(www\.)?github\.com\/[a-zA-Z0-9-]+\/[a-zA-Z0-9._-]+\/blob\/.+/;
  
  return simpleRepoRegex.test(url) || fileUrlRegex.test(url);
};

/**
 * Validate GitHub classic personal access token
 * @param {string} token - Token to validate
 * @returns {boolean}
 */
export const isValidGithubToken = (token) => {
  if (token === '') return true; // Optional token
  const classicTokenRegex = /^ghp_[a-zA-Z0-9]{36}$/;
  return classicTokenRegex.test(token);
};

/**
 * Extract owner and repo from GitHub URL
 * @param {string} url - GitHub URL
 * @returns {string} - Path in format /owner/repo
 */
export const extractGithubPath = (url) => {
  try {
    const pathname = new URL(url).pathname;
    return pathname.replace('.git', '');
  } catch (error) {
    return '';
  }
};
